/**
 * Suppliers page: the service chips and each supplier's More control.
 *
 * The server renders every supplier and every paragraph, with the chips and
 * the More buttons hidden, so without JS the whole panel reads in full. This
 * shows the controls and makes them work.
 */

function initSupplierFilters() {
	document.querySelectorAll('[data-awdd-supplier-filters]').forEach((filters) => {
		const section = filters.closest('section');
		const rows = Array.from(section ? section.querySelectorAll('[data-awdd-supplier]') : []);
		const chips = Array.from(filters.querySelectorAll('[data-awdd-supplier-filter]'));
		if (!rows.length || !chips.length) return;
		const shown = section.querySelector('[data-awdd-supplier-shown]');

		const apply = (slug) => {
			let count = 0;
			rows.forEach((row) => {
				const tags = (row.getAttribute('data-tags') || '').split(/\s+/).filter(Boolean);
				row.hidden = !(slug === '' || tags.includes(slug));
				if (!row.hidden) count += 1;
			});
			if (shown) shown.textContent = String(count);
		};

		chips.forEach((chip) => {
			chip.addEventListener('click', () => {
				chips.forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
				apply(chip.getAttribute('data-awdd-supplier-filter') || '');
			});
		});
		filters.hidden = false;
	});
}

function initSupplierMore() {
	document.querySelectorAll('[data-awdd-supplier-more]').forEach((button) => {
		const panel = document.getElementById(button.getAttribute('aria-controls') || '');
		if (!panel) return;
		const label = button.querySelector('[data-label]');
		const iconClosed = button.querySelector('[data-when="closed"]');
		const iconOpen = button.querySelector('[data-when="open"]');

		const set = (open) => {
			button.setAttribute('aria-expanded', open ? 'true' : 'false');
			panel.hidden = !open;
			// Only the label's own span changes, so the icons stay in place.
			if (label) label.textContent = button.getAttribute(open ? 'data-less' : 'data-more') || label.textContent;
			if (iconClosed) iconClosed.toggleAttribute('hidden', open);
			if (iconOpen) iconOpen.toggleAttribute('hidden', !open);
		};

		button.addEventListener('click', () => set(button.getAttribute('aria-expanded') !== 'true'));
		set(false);
		button.hidden = false;
	});
}

export default function initSuppliers() {
	initSupplierFilters();
	initSupplierMore();
}
